import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Config } from 'ionic-angular';
import { StatusBar, Splashscreen, Deeplinks } from 'ionic-native';
import { GlobalVars } from '../providers/global-vars';
import { ApiCaller } from '../providers/api-caller';
import {TranslateService} from 'ng2-translate/ng2-translate';



import { HomePage } from '../pages/home/home';
import { AccessCodesPage } from '../pages/access-codes/access-codes';
import { PartnersPage } from '../pages/partners/partners';
import { MyGatesPage } from '../pages/my-gates/my-gates';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
    @ViewChild(Nav) nav: Nav;
  rootPage = HomePage;

  constructor(public platform: Platform, public apiCaller : ApiCaller, public globalVars : GlobalVars, private translate: TranslateService,
             public config: Config) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.initTranslation();
        
    });
  }
     
   initTranslation() {
    this.globalVars.userLanguage = navigator.language.split('-')[0]; // use navigator lang if available
 //   userLang = /(he|fr|en|es|in|zh)/gi.test(userLang) ? userLang : 'en';
//    userLang = 'es'; 
    this.globalVars.userLanguage = /(en|es|he)/gi.test(this.globalVars.userLanguage) ? this.globalVars.userLanguage : 'en';
 //      if (this.platform.is('ios') && !this.platform.is('cordova'))
  //          this.globalVars.userLanguage = 'he';
       console.log("Language is: "+this.globalVars.userLanguage);
    if (this.globalVars.userLanguage == 'he'){
        this.globalVars.isRTL = true; 
        this.platform.setDir('rtl', true);
        this.config.set('ios','backButtonIcon', 'arrow-forward');
        this.config.set('android','backButtonIcon', 'arrow-forward');
    }
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');
 
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(this.globalVars.userLanguage);
    this.globalVars.translateGlobalMessages();
    
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts